<script>
    import {Form} from '../../../../helpers/Form/Form'

    export default {
        props: ['data', 'companyprop'],
        data() {
            return {
                userRequest: null,
                requestFrom: null,
                requestCourse: null,
                requestSummerCamp: null,
                requestEvent: null,
                requestDate: null,
                requestFromEmail: null,
                messages: this.data,
                form: new Form({
                    subject: '',
                    from: this.companyprop.email,
                    to: '',
                    text: '',
                    reservation_id: null,
                    user_id: null,
                    thread: null,
                    summer_camp_id: null,
                    course_id: null,
                    event_id: null
                })
            }
        },
        mounted() {
            this.updateFormData()
        },
        methods: {
            getFrom(userRequest) {
                if (userRequest) {
                    let userEmail = userRequest.from != this.companyprop.email ? userRequest.from : userRequest.to
                    let user = userRequest.user
                    let from = userEmail.split('@')
                    let requestFrom = userRequest.user_id ? user.first_name : from[0]

                    this.$set(this, 'requestFrom', requestFrom)
                    this.$set(this, 'requestFromEmail', userEmail)
                }
            },
            getCourse(userRequest){
                if (userRequest.course) {
                    let requestCourse = userRequest.course.name
                    this.$set(this.form, 'course_id', userRequest.course.id)
                    this.$set(this, 'requestCourse', requestCourse)
                }
            },
            getEvent(userRequest){
                if (userRequest.event) {
                    let requestEvent = userRequest.event.name
                    this.$set(this.form, 'event_id', userRequest.event.id)
                    this.$set(this, 'requestEvent', requestEvent)
                }
            },
            getSummerCamp(userRequest){
                if (userRequest.summer_camp) {
                    let requestSummerCamp = userRequest.summer_camp.name
                    this.$set(this.form, 'summer_camp_id', userRequest.summer_camp.id)
                    this.$set(this, 'requestSummerCamp', requestSummerCamp)
                }

            },
            getFormatDate(userRequest) {
                let date = moment(userRequest.created_at).format('D MMM YYYY')
                this.$set(this, 'requestDate', date)
            },
            onBackToList() {
                this.$emit('clear-selection')
            },
            updateFormData() {
                let userRequest = _.head(this.messages.filter(i => {
                    return i.from != this.companyprop.email || i.to != this.companyprop.email
                }));

                this.getFrom(userRequest)
                this.getFormatDate(userRequest)
                this.getCourse(userRequest)
                this.getSummerCamp(userRequest)
                this.getEvent(userRequest)

                this.$set(this, 'userRequest', userRequest)

                this.form.setData('subject', userRequest.subject)
                this.form.setData('to', this.requestFromEmail)
                this.form.setData('reservation_id', userRequest.reservation_id)
                this.form.setData('user_id', userRequest.user_id)
                this.form.setData('thread', userRequest.thread)
            },
            isOwner(message) {
                return message.from == this.companyprop.email
            },
            onSubmit() {
                this.form
                    .submit('post', route('companies.dashboard.requests', this.companyprop.slug))
                    .then(({contactRequest}) => {
                        let messages = this.messages
                        messages.push(contactRequest)
                        this.$set(this, 'messages', messages)
                        window.alerts.success("Email inviata con successo, l'utente ti risponderà su " + this.companyprop.email);

                        this.updateFormData()
                        
                        this.$emit('update-request', {
                            request: contactRequest
                        })
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/RequestDetail.vue